import React from 'react';
import { motion } from 'framer-motion';
import { GitMerge, Clock, EyeOff, Link2Off } from 'lucide-react';
const problems = [{
  icon: GitMerge,
  title: 'Scattered Task Trails',
  description: 'Teams juggle 5+ tools, nothing connects, context is lost between platforms.'
}, {
  icon: Clock,
  title: 'Repetitive Drudgework',
  description: 'Hours wasted on manual data entry, status updates, and copy-pasting between apps.'
}, {
  icon: EyeOff,
  title: 'Blind Spot Operations',
  description: "No unified view of what's running, what's stuck, or what needs attention."
}, {
  icon: Link2Off,
  title: 'Brittle Handoffs',
  description: 'When one person drops the ball, the entire chain collapses silently.'
}];
export function ProblemsSection() {
  return <section className="py-20 bg-white relative overflow-hidden" data-id="element-188">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-189">
        <div className="text-center mb-16" data-id="element-190">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-191">
            The Chaos Before Nimbusquest
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-192">
            Modern work is broken. Disconnected tools and manual processes are
            slowing you down.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-193">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-slate-50 p-6 rounded-xl border-l-4 border-sky-400 hover:shadow-lg transition-shadow" data-id="element-194">
              <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center text-sky-500 mb-4 shadow-sm" data-id="element-195">
                <problem.icon size={24} data-id="element-196" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-2" data-id="element-197">
                {problem.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-198">
                {problem.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}